function findProductPriceByQuantity(data, lookupValue) {
  if (!data || !data.length || !lookupValue) {
    return null;
  }

  let left = 0;
  let right = data.length - 1;

  while (left <= right) {
      const mid = Math.floor((left + right) / 2);

      if (data[mid].min === lookupValue) {
          return data[mid];
      } else if (data[mid].min < lookupValue) {
          if (mid + 1 <= right && data[mid + 1].min > lookupValue) {
              return data[mid];
          }
          left = mid + 1;
      } else {
          right = mid - 1;
      }
  }

  // If lookupValue is greater than the largest min value, return the last item
  if (lookupValue > data[data.length - 1].min) {
    return data[data.length - 1];
  }

  return null; // if not found
}

export default findProductPriceByQuantity

export function findProductPriceIndexByQuantity(data, lookupValue) {
  if (!data || !data.length || !lookupValue) {
    return null;
  }

  let left = 0;
  let right = data.length - 1;

  while (left <= right) {
      const mid = Math.floor((left + right) / 2);

      if (data[mid].min === lookupValue) {
          return mid;
      } else if (data[mid].min < lookupValue) {
          if (mid + 1 <= right && data[mid + 1].min > lookupValue) {
              return mid;
          }
          left = mid + 1;
      } else {
          right = mid - 1;
      }
  }

  // If lookupValue is greater than the largest min value, return the last item
  if (lookupValue > data[data.length - 1].min) {
    return data.length - 1
  }

  return null; // if not found
}
